import React, { useEffect, useState } from "react";
import "../../../../Assets/CSS/bulkorder.css";

import "../../oms.css";

import Up from "../../../../Assets/Images/OMS/up.svg";
import Down from "../../../../Assets/Images/OMS/down.svg";

import Rejection from "../../../../Assets/Images/OMS_New/rejected.svg";

import { useFormik } from "formik";
import { Button, Switch } from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";
import moment from "moment";

const RENT_FREQUENCY = [
  {
    name: "Daily",
    value: "DAILY",
  },
  {
    name: "Weekly",
    value: "WEEKLY",
  },
  {
    name: "BiWeekly",
    value: "BIWEEKLY",
  },
  {
    name: "Monthly",
    value: "MONTHLY",
  },
  {
    name: "Qurterly",
    value: "QURTERLY",
  },
  {
    name: "Semiannually",
    value: "SEMIANNUALLY",
  },
  {
    name: "Annually",
    value: "ANNUALLY",
  },
];

function RejectionDetailsBuyerForm({ omsData, getOMSData, orderId }) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";

  const [buyerRejectionDetails, setBuyerRejectionDetails] = useState(false);
  const [formDisable, setFormDisable] = useState(false);

  function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj?.constructor === Object;
  }

  const validate = (values) => {
    const errors = {};
    if (values.is_warehouse_insured) {
      if (!values.warehouse_insurance_number) {
        errors.warehouse_insurance_number = "Insurance number required";
      }
      if (!values.warehouse_insurance_provider) {
        errors.warehouse_insurance_provider = "Insurance provider required";
      }
      if (!values.warehouse_insurance_bared_by) {
        errors.warehouse_insurance_bared_by = "Insurance bared by required";
      }
      if (!values.warehouse_insurance_cost) {
        errors.warehouse_insurance_cost = "Insurance cost required";
      }
    }
    return errors;
  };

  const initialValues = {
    quantity: null,
    bag: null,
    reason: null,
    inventory_in_time: null,
    warehouse_rent_paid_date: null,
    warehouse_in_time: null,
    warehouse_name: null,
    warehouse_location: null,
    warehouse_rent: null,
    warehouse_rent_frequency: "",
    warehouse_rent_paid_amount: null,
    warehouse_rent_discount: null,
    is_warehouse_insured: false,
    warehouse_insurance_number: "",
    warehouse_insurance_provider: "",
    warehouse_insurance_bared_by: "",
    warehouse_insurance_cost: null,
  };

  const handleSubmit = async (values) => {
    const url = `/api/oms/return/${orderId}`;

    const payload = {
      product_id: omsData?.order_items?.[0]?.product_id || null,
      quantity: values?.quantity || null,
      reason: values?.reason || null,
      //"quality_parameters_id": 12,
      bags: values?.bag || null,
      primary_order_buyer: omsData?.user_id || null,
      available_quantity: values?.quantity || null,
      before_quality:
        omsData?.order_items?.[0]?.product?.quality_parameter || null,
      inventry_in_time: values?.inventory_in_time || null,
      warehouse_in_time: values?.warehouse_in_time || null,
      warehouse_rent_paid_date: values?.warehouse_rent_paid_date || null,
      warehouse_name: values?.warehouse_name || null,
      warehouse_location: values?.warehouse_location || null,
      wearhouse_rent: values?.warehouse_rent || null,
      warehouse_rent_frequency: values?.warehouse_rent_frequency || null,
      warehouse_rent_paid_amount: values?.warehouse_rent_paid_amount || null,
      warehouse_rent_discount: values?.warehouse_rent_discount || null,
      is_warehouse_insured: values?.is_warehouse_insured || false,
      warehouse_insurance_number: values?.warehouse_insurance_number || null,
      warehouse_insurance_provider:
        values?.warehouse_insurance_provider || null,
      warehouse_insurance_bared_by:
        values?.warehouse_insurance_bared_by || null,
        warehouse_insurance_cost:
        values?.warehouse_insurance_cost || null,
    };

    try {
      const { data } = await axios.post(url, payload);
      if (data.status) {
        formik.resetForm();
        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response ? error.response.message : "Error Occured");
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (isEmptyObject(omsData?.oms_standby || {})) {
      setFormDisable(false);
    } else {
      setFormDisable(true);
    }
    formik.setValues({
      ...formik.values,
      quantity: omsData?.oms_standby?.quantity || "",
      bag: omsData?.oms_standby?.bags || "",
      reason: omsData?.oms_standby?.reason || "",
      inventory_in_time: omsData?.oms_standby?.inventry_in_time
        ? moment(omsData?.oms_standby?.inventry_in_time).format("YYYY-MM-DD")
        : null,
      warehouse_rent_paid_date: omsData?.oms_standby?.warehouse_rent_paid_date
        ? moment(omsData?.oms_standby?.warehouse_rent_paid_date).format(
            "YYYY-MM-DD"
          )
        : null,
      warehouse_in_time: omsData?.oms_standby?.warehouse_in_time
        ? moment(omsData?.oms_standby?.warehouse_in_time).format("YYYY-MM-DD")
        : null,
      warehouse_name: omsData?.oms_standby?.warehouse_name || "",
      warehouse_location: omsData?.oms_standby?.warehouse_location || "",
      warehouse_rent: omsData?.oms_standby?.wearhouse_rent || "",
      warehouse_rent_frequency:
        omsData?.oms_standby?.warehouse_rent_frequency || "",
      warehouse_rent_paid_amount:
        omsData?.oms_standby?.warehouse_rent_paid_amount || "",
      warehouse_rent_discount:
        omsData?.oms_standby?.warehouse_rent_discount || "",
      is_warehouse_insured: omsData?.oms_standby?.is_warehouse_insured || false,
      warehouse_insurance_number:
        omsData?.oms_standby?.warehouse_insurance_number || null,
      warehouse_insurance_provider:
        omsData?.oms_standby?.warehouse_insurance_provider || null,
      warehouse_insurance_bared_by:
        omsData?.oms_standby?.warehouse_insurance_bared_by || null,
        warehouse_insurance_cost:
        omsData?.oms_standby?.warehouse_insurance_cost || null,
    });
  }, [formik.setValues, omsData]);

  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-1">
          {" "}
          <img src={Rejection} alt="" />
          <div className="ms-1">Rejection Details</div>
        </div>
        <div>
          {buyerRejectionDetails ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setBuyerRejectionDetails(!buyerRejectionDetails)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setBuyerRejectionDetails(!buyerRejectionDetails)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>
      <div>
        {buyerRejectionDetails ? (
          <></>
        ) : (
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div>
                  <label
                    for="quantity"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Quantity
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="quantity"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="quantity"
                    onChange={formik.handleChange}
                    value={formik.values.quantity}
                    placeholder="Enter Quantity"
                    disabled={isPending}
                  />
                  {formik.errors.quantity ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.quantity}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="bag"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Bags
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="bag"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="bag"
                    onChange={formik.handleChange}
                    value={formik.values.bag}
                    placeholder="Enter Total Number Of Bags"
                    disabled={isPending}
                  />
                  {formik.errors.bag ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.bag}
                    </div>
                  ) : null}
                </div>

                <div>
                  <label
                    for="inventory_in_time"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Inventory In Time
                  </label>
                  <input
                    type="date"
                    id="inventory_in_time"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="inventory_in_time"
                    onChange={formik.handleChange}
                    value={formik.values.inventory_in_time}
                    disabled={isPending}
                  />
                  {formik.errors.inventory_in_time ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.inventory_in_time}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_rent_paid_date"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Warehouse Rent Paid Date
                  </label>
                  <input
                    type="date"
                    id="warehouse_rent_paid_date"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="warehouse_rent_paid_date"
                    onChange={formik.handleChange}
                    value={formik.values.warehouse_rent_paid_date}
                    disabled={isPending}
                  />
                  {formik.errors.warehouse_rent_paid_date ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_rent_paid_date}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_in_time"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Warehouse In Time
                  </label>
                  <input
                    type="date"
                    id="warehouse_in_time"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="warehouse_in_time"
                    onChange={formik.handleChange}
                    value={formik.values.warehouse_in_time}
                    disabled={isPending}
                  />
                  {formik.errors.warehouse_in_time ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_in_time}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_name"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Warehouse Name
                  </label>
                  <input
                    type="text"
                    id="warehouse_name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="warehouse_name"
                    onChange={formik.handleChange}
                    value={formik.values.warehouse_name}
                    placeholder="Enter Warehouse Name"
                    disabled={isPending}
                  />
                  {formik.errors.warehouse_name ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_name}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_location"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Warehouse Location
                  </label>
                  <input
                    type="text"
                    id="warehouse_location"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="warehouse_location"
                    onChange={formik.handleChange}
                    value={formik.values.warehouse_location}
                    placeholder="Enter Warehouse Location"
                    disabled={isPending}
                  />
                  {formik.errors.warehouse_location ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_location}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_rent"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Warehouse Rent
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="warehouse_rent"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="warehouse_rent"
                    onChange={formik.handleChange}
                    value={formik.values.warehouse_rent}
                    placeholder="Enter Warehouse Rent (Rs)"
                    disabled={isPending}
                  />
                  {formik.errors.warehouse_rent ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_rent}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_rent_frequency"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Rent Frequency
                  </label>
                  <select
                    id="warehouse_rent_frequency"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    aria-label="Default select example"
                    name="warehouse_rent_frequency"
                    value={formik.values.warehouse_rent_frequency}
                    onChange={formik.handleChange}
                    disabled={isPending}
                  >
                    <option value="">Select Rent Frequency</option>
                    {RENT_FREQUENCY?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  {formik.errors.warehouse_rent_frequency &&
                  formik.touched.warehouse_rent_frequency ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_rent_frequency}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_rent_paid_amount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Warehouse Rent Paid Amount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="warehouse_rent_paid_amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="warehouse_rent_paid_amount"
                    onChange={formik.handleChange}
                    value={formik.values.warehouse_rent_paid_amount}
                    placeholder="Enter Warehouse Rent Paid Amount (Rs)"
                    disabled={isPending}
                  />
                  {formik.errors.warehouse_rent_paid_amount ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_rent_paid_amount}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="warehouse_rent_discount"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Warehouse Rent Discount
                  </label>
                  <input
                    type="number" onWheel={(e) => e.target.blur()}
                    id="warehouse_rent_discount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="warehouse_rent_discount"
                    onChange={formik.handleChange}
                    value={formik.values.warehouse_rent_discount}
                    placeholder="Enter Warehouse Rent Discount (Rs)"
                    disabled={isPending}
                  />
                  {formik.errors.warehouse_rent_discount ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.warehouse_rent_discount}
                    </div>
                  ) : null}
                </div>
                <div>
                  <label
                    for="is_warehouse_insured"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Is Warehouse Insured ?
                  </label>
                  <div className="flex justify-between">
                    <Switch
                      className="float-left"
                      checked={formik.values.is_warehouse_insured}
                      disabled={isPending}
                      onChange={(evt) => {
                        formik.setFieldValue(
                          `is_warehouse_insured`,
                          evt.currentTarget.checked
                        );
                      }}
                      inputProps={{
                        "aria-label": "controlled",
                        name: "is_warehouse_insured",
                      }}
                    />
                    {formik.values.is_warehouse_insured && (
                      <input
                        type="text"
                        id="warehouse_insurance_number"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-5/6 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name={`warehouse_insurance_number`}
                        placeholder="Warehouse Insurance Number"
                        value={formik.values.warehouse_insurance_number}
                        onChange={formik.handleChange}
                        disabled={isPending}
                      />
                    )}

                  </div>
                    {formik.values.is_warehouse_insured &&
                    formik.touched.warehouse_insurance_number ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1 text-center">
                        {formik.errors.warehouse_insurance_number}
                      </div>
                    ) : null}
                </div>
                {formik.values.is_warehouse_insured && (
                  <>
                    <div>
                      <label
                        for="warehouse_insurance_provider"
                        className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                      >
                        Warehouse Insurance Provider
                      </label>
                      <input
                        type="text"
                        id="warehouse_insurance_provider"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="warehouse_insurance_provider"
                        onChange={formik.handleChange}
                        value={formik.values.warehouse_insurance_provider}
                        placeholder="Enter Warehouse Insurance Provider"
                        disabled={isPending}
                      />
                      {formik.errors.warehouse_insurance_provider ? (
                        <div className="text-red-600 text-sm flex justify-start ms-1">
                          {formik.errors.warehouse_insurance_provider}
                        </div>
                      ) : null}
                    </div>
                    <div>
                      <label
                        for="warehouse_insurance_bared_by"
                        className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                      >
                        Warehouse Insurence Bared By
                      </label>
                      <input
                        type="text"
                        id="warehouse_insurance_bared_by"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="warehouse_insurance_bared_by"
                        onChange={formik.handleChange}
                        value={formik.values.warehouse_insurance_bared_by}
                        placeholder="Warehouse insureance bayed by"
                        disabled={isPending}
                      />
                      {formik.errors.warehouse_insurance_bared_by ? (
                        <div className="text-red-600 text-sm flex justify-start ms-1">
                          {formik.errors.warehouse_insurance_bared_by}
                        </div>
                      ) : null}
                    </div>
                    <div>
                      <label
                        for="warehouse_insurance_cost"
                        className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                      >
                        Warehouse Insurence Cost
                      </label>
                      <input
                        type="number" onWheel={(e) => e.target.blur()}
                        id="warehouse_insurance_cost"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="warehouse_insurance_cost"
                        onChange={formik.handleChange}
                        value={formik.values.warehouse_insurance_cost}
                        placeholder="Warehouse insureance cost"
                        disabled={isPending}
                      />
                      {formik.errors.warehouse_insurance_cost ? (
                        <div className="text-red-600 text-sm flex justify-start ms-1">
                          {formik.errors.warehouse_insurance_cost}
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
                <div>
                  <label
                    htmlFor="reason"
                    className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex kustify-start ms-1"
                  >
                    Reason for Rejection
                  </label>
                  <textarea
                    id="reason"
                    rows="4"
                    class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    value={formik.values.reason}
                    placeholder="Enter Reason For Rejection"
                    name="reason"
                    onChange={formik.handleChange}
                    disabled={isPending}
                  ></textarea>
                  {formik.errors.reason ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik.errors.reason}
                    </div>
                  ) : null}
                </div>
              </div>

              {
                <div className="flex justify-end mt-2">
                  <Button
                    variant="contained"
                    size="small"
                    type="submit"
                    sx={{ backgroundColor: "#0D9223" }}
                    disabled={isPending}
                  >
                    SAVE
                  </Button>
                </div>
              }
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default RejectionDetailsBuyerForm;
